import React, {useMemo} from 'react';
import useMortgage from "../../../../../../../../../providers/mortgage/useMortgage";
import {UploadStatuses} from "../../../../../../../../../../models";
import {Form, Input} from "antd";
import {useDebouncedCallback} from "../../../../../../../hooks/useDebouncedCallback";

function Rejector({uploadId}) {
    const mortgage = useMortgage()
    const upload = mortgage.uploads.find(item => item.id === uploadId);
    const initialValues = useMemo(() => {
        if (upload.status === UploadStatuses.REJECTED && upload.reason) {
            return {reason: upload.reason};
        }
        return {};
    }, [upload.status, upload.reason]);
    const debouncedSave = useDebouncedCallback( (values) =>{

        if (values.reason) {
            mortgage.mutate({
                update: {
                    target: `uploads[${uploadId}].reason`,
                    value: values.reason
                }
            })
        }
    }, 800) // adjust delay as needed
    // Stable debounced save handler

    // Forward changes to debounced save
    if (upload.status === UploadStatuses.REJECTED){
        return (
            <div>
                <span className="text-danger" style={{fontSize:14}}>Reason For Rejection</span>
                <Form initialValues={initialValues} layout="vertical" onValuesChange={debouncedSave} >
                    <Form.Item name="reason">
                        <Input.TextArea autoSize/>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    return null
}

export default Rejector;